import { cn } from "~/utils/cn";

interface IMandatoryLabelProps {
  inputId: string;
  label: string;
  isMandatory: boolean;
  hidden?: boolean;
  className?: string;
  isParkAction?: boolean;
}

export const MandatoryLabel = ({
  inputId,
  label,
  isMandatory,
  className,
  hidden,
  isParkAction = false,
}: IMandatoryLabelProps) => {
  const shouldShowMandatory = isMandatory && !isParkAction;
  
  return hidden ? null : (
    <label className={cn("text-sm font-medium text-gray-700", className)} htmlFor={inputId}>
      {label}
      {shouldShowMandatory && <span className="text-red-500">*</span>}
    </label>
  );
};
